<div class="milestone">
    <p>{{ milestone?.date | date: 'shortDate' }}</p>
    <p>{{ milestone?.milestone }}</p>
    <hr>
</div>
